export enum Page {
  Main = "",
  Signup = "signup",
  ExistedCustomer = "existed-customer",

  // AU
  Abn = "abn",
  SoleTrader = "sole-trader",
}
